import { noop } from '../../../../lib/utilities';
import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import Notification from './tile/notification';
import FittingPromotion from './tile/notification/fitting_promotion';
import FreeShipping from './tile/notification/free_shipping';

import { ProductBadge } from './tile/product_badge';
import { ShowDetails } from './tile/show_details';
import { imageIsNonFallbackPlaceholder } from '../../helper/image_is_non_fallback_placeholder';
import { generateClassName } from '../../../_modules/helper/generate_class_name';
import { Price } from './tile/price';
import { Logo } from '../brand/logo';
import LazyLoad from 'react-lazyload';
import ShippingQuote from './tile/shipping_quote';
import { showAction } from '../../actions/catalog_postcode_actions';
import ErrorBoundary from '../../../_modules/error/error_boundary';
import { types as productTypes } from '../../../_constants/product/types';
import FittingStation from './tile/fitting_station';
import getTranslatedText from '../../helper/get_translated_text';
import isFSFDisabled from '../../helper/disable_fsf_for_store';
import Tooltip from '../tooltip/tooltip';
import Translation from '../translation/translation';
import ProductEuLabels from './product_eu_labels';

const lazyContainerClassNames = generateClassName({
  'product-tile': true,
  'product-tile--out-of-stock': ({ stock }) => !stock,
});

const DRRating = React.lazy(() => import('./tile/dr_rating'));

const openPostcode = () => {
  return showAction();
};

const getPromotionData = (idx, type) => {
  let result = '';

  if (type === 'header') {
    result = 'PREMIUM';
    if (idx === 1) {
      result = 'VALUE';
    } else if (idx === 2) {
      result = 'BUDGET';
    }
  } else if (type === 'text') {
    result = 'Top notch quality and performance';
    if (idx === 1) {
      result = 'Performance without breaking bank';
    } else if (idx === 2) {
      result = 'Affordable tyres that get the job done';
    }
  } else if (type === 'color') {
    result = '#000000';
    if (idx === 1) {
      result = '#1ED278';
    } else if (idx === 2) {
      result = '#3D83E1';
    }
  }

  return result;
};

function Tile(props) {
  const {
    sku,
    dimensions,
    stock,
    url,
    productImage,
    manufacturer,
    hideManufacturerLogo,
    model,
    profileText,
    price,
    reviews,
    freeShipping,
    showFreeFitting,
    shippingTime,
    onNotifyMeClick,
    staticImagesUrl,
    priceRrp,
    showShowDetailsButton,
    hasImage,
    noImageUrl,
    priceRaw,
    fittingPromotion,
    catalogPromotion,
    onOpenFSFClick,
    onClickAddToCart,
    badges,
    isNewProduct,
    labelFuelEfficiency,
    labelWetGrip,
    labelNoise,
    manufacturerImage,
  } = props.data;
  const { buyerAssistUrl } = props;

  let {
    bestseller,
    buy4for3,
    clearance,
    instantCash,
    newProduct,
    savePercent,
    tyroolasChoice,
    metroArea,
    productImageAltText,
    productType,
  } = props.data;
  bestseller = bestseller || false;
  buy4for3 = buy4for3 || false;
  clearance = clearance || false;
  instantCash = instantCash || false;
  newProduct = newProduct || false;
  savePercent = savePercent || false;
  tyroolasChoice = tyroolasChoice || true;
  metroArea = metroArea || '';
  productImageAltText = productImageAltText || manufacturer + ' ' + model + ' ' + dimensions;

  let fittingPromotionAvailable = false;
  if (
    null !== fittingPromotion &&
    'promotionName' in fittingPromotion &&
    (fittingPromotion.promotionName === 'next_day_fitting' ||
      fittingPromotion.promotionName === 'free_fitting' ||
      fittingPromotion.promotionName === 'free_mobile_fitting')
  ) {
    fittingPromotionAvailable = true;
  }

  const isNotOutOfStock = stock > 0;
  const productTypeIsTyreCar = productType === productTypes.TYRE_CAR;
  const productTypeIsTyreMoto = productType === productTypes.TYRE_MOTO;
  const isProductWheel = productType === productTypes.WHEEL;
  let { store } = TYROOLA.globals;
  const isShippingQuoteAllowed = ['AU', 'AU_SCA', 'AU_NRMA', 'NZ', 'NZ_SCA'].indexOf(store) >= 0;
  const shippingPostcode =
    props.shippingDataHasValue &&
    props.shippingData.length > 0 &&
    props.shippingData[0].statusCode === 200 &&
    props.shippingData[0].body.addressShipping
      ? props.shippingData[0].body.addressShipping.postcode
      : '';

  const notLazyLoadImage = !!(
    (props.index <= 2 && $(window).width() < 768) ||
    (props.index <= 3 && $(window).width() >= 768)
  );
  const isValidDRStore = TYROOLA.globals.driverReviewsEnabled;

  let choiceAwardBadges = '';
  if (props.data.productBadges && props.data.productBadges.length) {
    choiceAwardBadges = [props.data.productBadges[0]].map((b) => (
      <img
        className="choice-award-badge product-tile__image product-tile__image-dr-badge"
        alt={'choice-award-badge'}
        src={b.imageUrl}
      />
    ));
  }

  let mostPopularVehicleElem = '';
  if (props.data.mostPopularVehicle) {
    mostPopularVehicleElem = (
      <div className="product-badge product-badge--black most-popular-vehicle-badge" style={{ marginTop: '10px' }}>
        <span>Popular for</span>
        <span className="most-popular-vehicle-badge-text">
          {props.data.mostPopularVehicle.make} {props.data.mostPopularVehicle.model}
        </span>
      </div>
    );
  }

  return (
    <>
      <ProductBadge
        isRecommended={props.isRecommended}
        product={{
          badges: badges,
          bestseller: bestseller,
          buy4for3: buy4for3,
          clearance: clearance,
          instantCash: instantCash,
          newProduct: newProduct,
          savePercent: savePercent,
          tyroolasChoice: tyroolasChoice,
          manufacturer: manufacturer,
          isNewProduct,
        }}
      />
      <div className={lazyContainerClassNames({ stock })}>
        <div className="display-flex justify-content-space-between">
          <div className="product-tile__brand product-tile__brand--BF-GOODRICH">
            <Logo
              manufacturer={manufacturer}
              hideManufacturerLogo={hideManufacturerLogo}
              manufacturerImage={manufacturerImage}
            />
          </div>
          <div className="product-tile__promotion-type" style={{ background: getPromotionData(props.index, 'color') }}>
            {getPromotionData(props.index, 'header')}
          </div>
        </div>
        <div className="justify-content-space-between">
          <div className="product-tile__product-image">
            {notLazyLoadImage && (
              <a className="product-tile__product-link" href={url} onClick={() => props.onProductClick(sku)}>
                <img
                  className="product-tile__image"
                  alt={productImageAltText}
                  src={hasImage ? productImage : noImageUrl}
                />
              </a>
            )}
            {!notLazyLoadImage && (
              <LazyLoad height={180} once>
                <a className="product-tile__product-link" href={url} onClick={() => props.onProductClick(sku)}>
                  <img
                    className="product-tile__image"
                    alt={productImageAltText}
                    src={hasImage ? productImage : noImageUrl}
                  />
                </a>
              </LazyLoad>
            )}
            {!hasImage && imageIsNonFallbackPlaceholder(noImageUrl) && (
              <Tooltip
                label={getTranslatedText('product-image-illustration-only-label')}
                content={getTranslatedText('product-image-illustration-only')}
                additionalClassNames={['product-image-placeholder-text', 'dotted-underline']}
              />
            )}
          </div>

          {choiceAwardBadges ? (
            <a style={{ position: 'relative' }} href={url} onClick={() => props.onProductClick(sku)}>
              {choiceAwardBadges}
            </a>
          ) : (
            ''
          )}

          <ProductEuLabels
            spinachId={sku}
            labelFuelEfficiency={labelFuelEfficiency}
            labelWetGrip={labelWetGrip}
            labelNoise={labelNoise}
          />
        </div>

        <a className="product-tile__product-link" href={url} onClick={() => props.onProductClick(sku)}>
          <h2 className="product-tile__model">
            {manufacturer} {model}
          </h2>

          <h2 className="product-tile__size">{dimensions}</h2>

          {isValidDRStore && (
            <ErrorBoundary>
              <Suspense fallback={<div>Loading...</div>}>
                <DRRating manufacturer={manufacturer} model={profileText} />
              </Suspense>
            </ErrorBoundary>
          )}
        </a>

        <div
          className="product-tile__promotion-type-text"
          style={{ background: getPromotionData(props.index, 'color') }}
        >
          {getPromotionData(props.index, 'text')}
        </div>

        {mostPopularVehicleElem}
      </div>

      <ShowDetails id={sku} showShowDetailsButton={showShowDetailsButton} />

      {buyerAssistUrl && (
        <a
          className="btn btn-primary btn-lg btn-round col-xs-12"
          href={buyerAssistUrl}
          rel="noreferrer"
          target="_blank"
        >
          {getTranslatedText('product-oscar-buyer-assist')}
        </a>
      )}

      <div className="product-tile__bottom-section">
        {fittingPromotion && fittingPromotion && !isFSFDisabled() ? (
          <FittingPromotion fittingPromotion={fittingPromotion} />
        ) : null}

        <FreeShipping
          metroArea={metroArea}
          staticImagesUrl={staticImagesUrl}
          postcode={shippingPostcode}
          freeShipping={freeShipping}
        />

        {isShippingQuoteAllowed && props.shippingDataHasValue && props.shippingFees}
        {isShippingQuoteAllowed && !props.shippingDataHasValue && stock > 0 && (
          <ShippingQuote openPostcode={openPostcode} httpRequestShippingFees={props.httpRequestShippingFees} />
        )}

        {productTypeIsTyreCar && isNotOutOfStock && !fittingPromotionAvailable && !isFSFDisabled() && (
          <FittingStation productSku={sku} staticImagesUrl={staticImagesUrl} onOpenFSFClick={onOpenFSFClick} />
        )}
      </div>

      <div className="product-tile-price-btn-section">
        <Price
          price={price}
          badges={badges}
          priceRaw={priceRaw}
          priceRrp={priceRrp}
          currencyIsoCode={props.currencyIsoCode}
          onSeeHowItWorksClick={props.onSeeHowItWorksClick}
          buy4for3={buy4for3}
          priceDiscount={props.data.priceDiscount}
        />

        {stock > 0 && productTypeIsTyreCar && (
          <>
            <div className="add-to-cart sidebar__row-container--has-fitting">
              <Translation
                tagName="a"
                className="add-to-cart__button justify-content-center align-items-center"
                style={{ display: 'flex' }}
                href={url}
                onClick={() => props.onProductClick(sku)}
                translationKey="product-mixed-order-form-show-details-cta"
              />
            </div>
          </>
        )}

        {stock > 0 && (isProductWheel || productTypeIsTyreMoto) && (
          <>
            <div className="add-to-cart sidebar__row-container--has-fitting">
              <Translation
                tagName="a"
                className="add-to-cart__button justify-content-center align-items-center"
                style={{ display: 'flex' }}
                href={url}
                onClick={() => props.onProductClick(sku)}
                translationKey="product-mixed-order-form-show-details-cta"
              />
            </div>
          </>
        )}
      </div>

      <Notification
        stock={stock}
        fittingPromotion={fittingPromotion}
        shippingTime={shippingTime}
        onNotifyMeClick={onNotifyMeClick}
        sku={sku}
        price={price}
        productType={productType}
        productBatchStocks={props.productBatchStocks}
        httpRequestProductBatchStocks={props.httpRequestProductBatchStocks}
        onAlternativeProductStockClick={props.onAlternativeProductStockClick}
      />
    </>
  );
}

Tile.propTypes = {
  data: PropTypes.shape({
    stock: PropTypes.number.isRequired,
    priceRaw: PropTypes.number.isRequired,
    sku: PropTypes.string.isRequired,
    dimensions: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    productImage: PropTypes.string.isRequired,
    noImageUrl: PropTypes.string.isRequired,
    manufacturer: PropTypes.string.isRequired,
    manufacturerImage: PropTypes.string.isRequired,
    model: PropTypes.string.isRequired,
    price: PropTypes.string.isRequired,
    shippingTime: PropTypes.string.isRequired,
    staticImagesUrl: PropTypes.string.isRequired,
    hasImage: PropTypes.bool.isRequired,
    hideManufacturerLogo: PropTypes.bool.isRequired,
    showFreeFitting: PropTypes.bool.isRequired,
    reviews: PropTypes.object.isRequired,
    onNotifyMeClick: PropTypes.func.isRequired,
    onOpenFSFClick: PropTypes.func.isRequired,
    onClickAddToCart: PropTypes.func.isRequired,
    priceRrp: PropTypes.string,
    metroArea: PropTypes.string,
    bestseller: PropTypes.bool,
    buy4for3: PropTypes.bool,
    clearance: PropTypes.bool,
    instantCash: PropTypes.bool,
    newProduct: PropTypes.bool,
    savePercent: PropTypes.bool,
    tyroolasChoice: PropTypes.bool,
    showShowDetailsButton: PropTypes.bool,
    productType: PropTypes.string,
  }).isRequired,
  buyerAssistUrl: PropTypes.string,
  shippingData: PropTypes.array,
  shippingDataHasValue: PropTypes.bool.isRequired,
  shippingFees: PropTypes.object.isRequired,
  currencyIsoCode: PropTypes.string.isRequired,
  onSeeHowItWorksClick: PropTypes.func.isRequired,
  onProductClick: PropTypes.func,
  httpRequestShippingFees: PropTypes.object.isRequired,
  productBatchStocks: PropTypes.object,
  httpRequestProductBatchStocks: PropTypes.object.isRequired,
  onAlternativeProductStockClick: PropTypes.func.isRequired,
};

Tile.defaultProps = {
  onProductClick: noop,
  shippingData: [],
  productBatchStocks: [],
};

export default Tile;
